import { Button, Card, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const ValvesServicesModal = (props) => {
  const { t } = useTranslation();
  const title = t('valveModalTitle');

  return (
    <Modal
      {...props}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="h1">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('valveModalDesc')}</p>
        <Card className="px-4">
          <ul>
            <li>{t('valveService1')}</li>
            <li>{t('valveService2')}</li>
            <li>{t('valveService3')}</li>
            <li>{t('valveService4')}</li>
            <li>{t('valveService5')}</li>
          </ul>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => props.onHide(title)}>{t('getQuote')}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ValvesServicesModal;
